// extracted by mini-css-extract-plugin
export default {"chatNotesContainer":"pzrr_D188yCSZ3kPvBGT","chatNotesActionLoadingContainer":"Ke2TwACK7IJpIdaTrl58"};